(function(w, d, $){
  
  /*****
   * サイト設定
   */
  w.siteinfo = {
    tagmanager:       'GTM-W2365D6',
    viewport:         'width=1200'
  }

  /*****
   * Promise
   */
  w.load = {
    'header': new $.Deferred,
    'contentFooter': new $.Deferred,
    'footer': new $.Deferred,
  };

  /*****
   * VIEWPORT上書き
   */
  (function (d, h, m, p) {
    if ($.UA.is_mobile) return;
    var f = d.getElementsByTagName(h)[0],j = d.createElement(m);
    j.name = p[0];j.content = p[1];f.insertBefore(j, null);
  })(document, 'head', 'meta', ['viewport', w.siteinfo.viewport]);

  /*****
   * Google Tag Manager
   */
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer',w.siteinfo.tagmanager);

  /*****
   * デバイスごとのファイル読み込み
   */
  $.require({
    disableCache:false,
    '*':[
      '/asset/js/utility.min.js',
      '/asset/js/vendor/jquery.easing.1.3.js'
    ],
    sp:{
      '*':[
        '/asset/js/vendor/modernizr.js'
      ]
    }
  });
 
  /*****
   * コンテンツごとのファイル読み込み
   */
  $.require({
    disableCache:false,
    '*':{
      '/': [
        '/asset/css/top.min.css',
        '/asset/js/vendor/slick.min.js',
        '/asset/js/top.min.js'
      ],
      '/house': [
        '/asset/css/house.min.css',
        '/asset/js/house.min.js'
      ],
      '/itakura': [
        '/asset/css/itakura.min.css?ts=20201007',
        '(css)/asset/css/vendor/swiper-bundle.min.css',
        '(css)/asset/css/vendor/lity.min.css',
        '(js)/asset/js/vendor/swiper-bundle.min.js',
        '(js)/asset/js/vendor/lity.min.js',
        '/asset/js/itakura.min.js'
      ],
      '/aboutus': [
        '/asset/css/aboutus.min.css'
      ],
      '/exsample': [
        '/asset/css/example.min.css?ts=20201015',
        '/asset/js/example.min.js?ts=20201015'
      ]
    },
  });

  // DOM Ready
  $(() => {

    // SP用フッターナビ読み込み
    // (function(){
    //   if( !is_content('inquiry') ){
    //     $('.pageBottomLink','#footer').spFooterNav({
    //       data:{
    //         tel: '000-000-0000',
    //         title:{
    //           form: 'お問い合わせフォーム'
    //         }
    //       }
    //     });
    //   }
    // }());

    //header.html, footer.html読み込み
    (function(_){
      $.each(_,function(i,__){
        var mes = 'loadhtml error: ';
        $.get(__.loadhtml)
          .done(function(html){
            if(__.$target[__.method](html).length != 0){ __.callback(this,__) }
            else{
              mes+='Not found DOM $(\'%s\').\nCouldn\'t load \'%s\'';
              console.error(mes,__.$target.selector,this.url);
            }
            w.load[__.name].resolve(html)
          }).fail(function(data){ //ajaxの通信に失敗した場合
            mes+='Ajax failed \'%s\'\n%s (%s)';console.error(mes,this.url,data.statusText,data.status);
            w.load[__.name].reject(data)
            return false;
          });
      });
    }([
        {
          name: 'footer',
          loadhtml: '/asset/html/footer.html',
          $target: $('footer #footerNav'),
          method:'replaceWith',
          callback: function(r,_){
            console.info('%c%s%c is loaded','font-weight: bold',r.url,'');
          }
        },
        {
          name: 'contentFooter',
          loadhtml: '/asset/html/contentFooter.html?ts=20201007',
          $target: $('footer,#footer.ui-footer'),
          method:'before',
          callback: function(r,_){
            console.info('%c%s%c is loaded','font-weight: bold',r.url,'');
            $('.homeContentslist').insertBefore('#footer');
          }
        },
        {
          name: 'header',
          loadhtml: '/asset/html/header.html',
          $target: $('header'),
          method:'replaceWith',
          callback: function(r,_){
            console.info('%c%s%c is loaded','font-weight: bold',r.url,'')
            // gmenu current
            $('header .p-gmenu').currentMenu({mode:1,default:999});
            $.fixHouseGmenuCurrent();
          }
        }
    ]));

    // <body>にクラス付与
    $.bodyClass();

    // svgスプライト読み込み
    $.loadSVG();

    // htmlデータ読み込み
    $('[data-load-html]').loadHtml();

    // ページングテキスト
    $.pagingText({
      prev:'前へ',
      next:'次へ',
      list:'一覧'
    });

    // プライバシー・会社概要・サイトマップのコンテンツタイトル
    (function(cnt,path){
      var page = path.match(/^\/([^/]+)\.php$/i);
      if(!page || !cnt[page[1]]) return false;
      var $title = $(`<h2>${cnt[page[1]]}</h2>`),
          $container = $('<section class="mainImg"><div class="mainImgInner"></div></section>');
      $title.appendTo($container.find('.mainImgInner'));
      $container.insertAfter('#gmenu');
      $('.moduletitle').remove();
      var bodyClass = $('body').attr('class').replace(/[?|&]ipsw=\d/,'');
      $('body').attr('class',bodyClass);
    }({
      'sitemap':'サイトマップ',
      'privacy':'プライバシーポリシー',
      'profile':'会社概要'
    },location.pathname));

    // スマホフッターカスタム
    (function(_){ if(!$.UA.is_mobile && _.$footer.length == 0) return;
      _.$footer.parent().insertAfter( _.$needle );
    }({
      $footer: $('.detailFooter .pageingBtnBlock'),
      $needle: ( $('.listContents').length )? $('.listContents') : $('.element_detail').parent()
    }));

    // ページトップリンクをスクロール量で表示する
    // $.scrollspy({
    //   trigger:200,
    //   onBefore: function(pos){
    //     $('.go-to-top__wrap').addClass('hidden');
    //   },
    //   onAfter: function(pos){
    //     $('.go-to-top__wrap').removeClass('hidden');
    //   }
    // });

    // メニュー追加
    // $.addGlobalNav([
    //   ['<li><a href="/feature/?mode=detail&article=2">事業案内</a></li>',false,2]
    // ])

    // SPハンバーガーメニュー: house記事2リンク差し込み（#hybsMob があるページのみ）
    (() => {
      const initSpHouseMenu = () => {
        if ( !d.getElementById('hybsMob') ) return

        const $list = $('#header_menu .contentslist')
        if ( !$list.length || $list.data('house-about-inserted') ) return
        if ( !$list.find('a[href="/house/"]').length ) return

        const $item = $(
          '<li class="p-spmenu-house-about">' +
            '<a href="/house/?mode=detail&article=2" class="icon-arrow-r"> 丸富建綜について</a>' +
          '</li>'
        )

        const $items = $list.children('li')
        const insert_at = 5 // 上から6番目

        if ( $items.length > insert_at ) {
          $item.insertBefore( $items.eq(insert_at) )
        } else {
          $list.append( $item )
        }

        try {
          if ( $list.hasClass('ui-listview') ) $list.listview('refresh')
        } catch (e) {}

        $list.data('house-about-inserted', true)

        if ( !/^\/house(\/|$)/.test(w.location.pathname) ) return

        const m = w.location.search.match(/[?&]article=(\d+)/)
        const article_id = m ? parseInt(m[1], 10) : 1

        $list.find('li').removeClass('ui-btn-active')

        if ( article_id === 2 ) {
          $list.find('a[href*="article=2"]').closest('li').addClass('ui-btn-active')
        } else {
          $list.find('a[href="/house/"]').closest('li').addClass('ui-btn-active')
        }
      }

      initSpHouseMenu()
      $(d).on('pagecreate', '#hybsMob', initSpHouseMenu)
    })()

  });

  $(w).on('load',function(){

    setTimeout(() => d.documentElement.classList.add('loaded'),500)

  });

}(window, document, jQuery));